// extracted by mini-css-extract-plugin
module.exports =  {"segment":"HdmoMf34VEFn6yfP1UXD","empty":"cDAfduLDFo4HRrSeiUxQ","endpointType":"nX0ZWV69E9t_7YdswaE7"};